import React, { useState, useEffect } from 'react';

const ConnectionStatusBanner = ({ isConnected, countdown, hasActiveOrder }) => {
    const [wasDisconnected, setWasDisconnected] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        if (!isConnected && hasActiveOrder) {
            setWasDisconnected(true);
            setShowSuccess(false);
        }
    }, [isConnected, hasActiveOrder]);

    useEffect(() => {
        if (isConnected && wasDisconnected) {
            setShowSuccess(true);
            const timer = setTimeout(() => {
                setShowSuccess(false);
                setWasDisconnected(false);
            }, 2500);
            return () => clearTimeout(timer);
        }
    }, [isConnected, wasDisconnected]);

    const shouldShow = (!isConnected && hasActiveOrder) || showSuccess;

    return (
        <div
            className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ease-out ${
                shouldShow ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
            }`}
        >
            <div
                className={`flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white transition-colors duration-300 ${
                    showSuccess ? 'bg-green-500' : 'bg-amber-500'
                }`}
            >
                {showSuccess ? (
                    <>
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span>Connected</span>
                    </>
                ) : (
                    <>
                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                        </svg>
                        <span>Reconnecting{countdown !== null ? `... retrying in ${countdown}s` : '...'}</span>
                    </>
                )}
            </div>
        </div>
    );
};

export default ConnectionStatusBanner;
